import { useState } from "react";
import "./styles.css";

import icon from "../../assets/icontel.png";

const CtaTel = (props) => {
  const [text, setText] = useState("(92) 99331-0599");

  return (
    <button id="ctaTel">
      <a href="tel:993310599">
        <figure>
          <img src={icon} alt="Ícone do Telefone" />
        </figure>
        <p>{text}</p>
      </a>
    </button>
  );
};

export default CtaTel;
